function checkBreakPoint() {
  var w = $(window).width();
  $(".top-collection-three-colomn").each(function () {
    var $el = $(this);
    if (w <= 1024) {
      if ($el.hasClass("slick-initialized")) return;

      var options = {
        infinite: true,
        slidesToShow: 1,
        dots: true,
        arrows: false,
      };

      if ($el.attr("data-auto-rotate") === "true") {
        var speed = parseInt($el.attr("data-auto-rotate-speed"), 10);
        options.autoplay = true;
        options.autoplaySpeed = isNaN(speed) ? 4000 : speed;
        options.pauseOnHover = true;
        options.pauseOnFocus = true;
      }

      $el.slick(options);
    } else if ($el.hasClass("slick-initialized")) {
      $el.slick("unslick");
    }
  });
}

$(window).resize(function () {
  checkBreakPoint();
});

$(document).ready(function () {
  checkBreakPoint();
});

document.addEventListener("shopify:section:load", checkBreakPoint);
document.addEventListener("shopify:section:unload", function (event) {
  var $section = $(event.target).find(".top-collection-three-colomn.slick-initialized");
  if ($section.length) {
    $section.slick("unslick");
  }
});
